import React from 'react';
import { getDic } from '../assets/i18n/dictionary';
import { getConfigListByPage, getCoordinateList } from '../services/configService';
import { insertNewAccess, getSystemActions } from '../services/accessService';
import { isMobile } from "react-device-detect";

//Imports de components
import {
    Container,
    FormRow,
    ActivityIndicator,
    MenuButton,
    BackButton,

    MobileRender,
    ImageMapRender,
    Hall3D
} from '../components';

class DeskHallPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            configList: [],
            mobileRender: false,

            //Configurações default
            imageURLBackground_1600x900: "",
            map_1600x900: {
                name: "my-map",
                areas: [
                    { name: "ELEMENT-001", shape: "poly", coords: [90, 304, 268, 321, 267, 635, 83, 659], tooltip: "" },
                    { name: "ELEMENT-002", shape: "poly", coords: [1235, 327, 1399, 310, 1402, 656, 1239, 631], tooltip: "" },
                ]
            }
        }
    }

    async componentDidMount() {
        //Aplica configurações
        const configList = await getConfigListByPage(this.props.match.url);

        configList.find(item => {
            if (item.codeScreen === "NO-MOBILE") {
                this.setState({ mobileRender: true });
            }
            return null;
        });

        const coordinateList = await getCoordinateList(this.state.map_1600x900, configList);

        this.setState({ isLoading: false, configList: configList, map_1600x900: coordinateList });

        await insertNewAccess(this.props.match.url, "", getSystemActions().accessPage);
    }

    async componentWillUnmount() {
        await insertNewAccess(this.props.match.url, "", getSystemActions().exitPage);
        // window.location.reload();
    }

    componentDidCatch(e) {
        var error = e.toString();

        if (error.includes("Error: Maximum update depth exceeded")) {
            window.location.reload();
        }
    }

    render() {
        if (this.state.isLoading)
            return (
                <Container background="#e8eced" align="center" >
                    <FormRow align="center">
                        <ActivityIndicator />
                    </FormRow>
                </Container>
            );
        if (this.state.configList.find(e => e.codeScreen == 'ENABLE_HALL_3D'))
            return (
                <React.Fragment>
                    <MenuButton history={this.props.history} />
                    <BackButton
                        history={this.props.history}
                        color="#212121"
                    >
                        {getDic("voltar").toUpperCase()}
                    </BackButton>

                    <Hall3D
                        history={this.props.history}
                        hall_360_url={this.state.configList.find(e => e.codeScreen == 'ENABLE_HALL_3D').url[0]}
                        configList={this.state.configList}
                    />
                </React.Fragment>
            )
        return (
            <div>
                {!this.props.isModal && (
                    <>
                        <MenuButton history={this.props.history} />
                        <BackButton history={this.props.history} color="#212121">
                            {getDic("voltar").toUpperCase()}
                        </BackButton>

                    </>
                )}

                {isMobile && this.state.mobileRender ? (
                    <MobileRender
                        configList={this.state.configList}
                        defaultImage={this.state.imageURLBackground_1600x900}
                        history={this.props.history}
                    />
                ) : (
                    <div>
                        <ImageMapRender
                            configList={this.state.configList}
                            history={this.props.history}
                            defaultImage={this.state.imageURLBackground_1600x900}
                            defaultMap={this.state.map_1600x900}
                        />
                    </div>
                )
                }
            </div >
        )
    }
}

export default DeskHallPage
